<script setup lang="ts">

</script>

<template>
  <section class="block2">
    <div class="blockCenter">
      <div class="titleWrapper">
        <img src="/img/about/block2-功能介绍.png" alt="" class="imgTitle">
      </div>

      <!--人工智能商城-->
      <section class="card card1">
        <div class="titleFloor">
          <img src="/img/about/block2-功能介绍装饰.png" alt="" class="iconDecorate">
          <img src="/img/about/block2-人工智能商城1.png" alt="" class="iconTitle">
        </div>
        <div class="contentFloor">
          <img src="/img/about/block2-人工智能商城图.png" alt="" class="imgMain">
          <div class="contentWrapper">
            <img src="/img/about/block2-人工智能商城2.png" alt="" class="imgTitle">
            <div class="content">
              <p>
                AI-智能体平台是一种基于人工智能(AI)技术的电子商务解决方案。为响应2024年第十四届全国人民代表大会“人工智能+”发展创新号召，人工智能商城将先进的人工智能算法与商城运营、管理、营销、服务等各个环节紧密结合，为商家和消费者提供了更为高效、智能的购物体验。
              </p>
              <p>
                AI-智能体平台不仅推动了电子商务行业的发展，也加速了人工智能技术在商业领域的应用，未来更将广泛应用于各类电子商务领域，如综合电商平台、垂直电商平台、社交电商平台等。
              </p>
              <p>
              </p>
              平台既可以为中小企业商家提供一站式的电商解决方案，帮助商家快速搭建、运营电商平台，提高运营效率和盈利能力，同时也为传统企业商城平台构建起智能网络、智能管理、智能客服、智能商业、智能购物等全新的电商生态服务体系。
              <div class="line"></div>
              <p class="p1">
                “人工智能商城”本身也孕育着一批新兴业态，特别是互动共享、AI智慧生成、数字人直播、数字人定制及电商运营等领域更是有自己独特的发展创新能力，可给中小企业在电商发展和智能应用中提供更为完善的商业服务。
              </p>
            </div>
          </div>
        </div>
      </section>
      <!--数字人直播-->
      <section class="card card2">
        <div class="titleFloor">
          <img src="/img/about/block2-功能介绍装饰.png" alt="" class="iconDecorate">
          <img src="/img/about/block2-数字人直播1.png" alt="" class="iconTitle">
        </div>
        <div class="contentFloor">
          <div class="contentWrapper">
            <img src="/img/about/block2-数字人直播2.png" alt="" class="imgTitle">
            <div class="content">
              <p>
                虚拟数字人是系统运用人工智能、大数据、数字技术等通过拟人3D建模创建出来的、与人类形象接近的数字化人物形象。系统利用强大的智能(AI)技术打破物理界限，驱动数字人提供拟人服务和体验是其核心价值。超写实、工具化、强交互是未来数字人智能应用发展的先进趋势。
              </p>
              <p>
              </p>
              数字人在企业商业发展类领域中有着重要广泛的应用，主要可以扮演着品牌代言人、客服人员、虚拟商店员工、品牌营销，直播带货、企业培训讲解等各类商业服务角色。随着技术的不断进步，数字人在各个领域的创新应用还将不断增加。企业应用数字人直播或者定制自己的数字人直播将是未来企业发展的必经之路。人工智能商城利用数字人给企业打造属于自己的数字人直播平台，更加形象生动的介绍自己企业的产品和信息，既提升企业宣传形象又节约人力成本，还能获得更多客户关注度。
            </div>
          </div>
          <img src="/img/about/block2-数字人直播图.png" alt="" class="imgMain">
        </div>
      </section>
      <!--智能客服-->
      <section class="card card3 float-start">
        <div class="titleFloor">
          <img src="/img/about/block2-功能介绍装饰.png" alt="" class="iconDecorate">
          <img src="/img/about/block2-智能客服1.png" alt="" class="iconTitle">
        </div>
        <div class="contentFloor">
          <img src="/img/about/block2-智能客服图.png" alt="" class="imgMain">
          <div class="contentWrapper">
            <img src="/img/about/block2-智能客服2.png" alt="" class="imgTitle">
            <div class="content">
              <p>
                智能客服是在大规模知识处理基础上发展起来的一项面向各企业和行业应用的技术手段.
              </p>
              <p>
                它是（大规模知识处理技术、自然语言理解技术、知识管理技术、自动问答系统、推理技术等等），具有行业通用性，不仅为企业提供了细粒度知识管理技术，还为企业与海量用户之间的沟通建立了一种基于自然语言的快捷有效的技术手段
              </p>
              <p>
                同时利用人工智能技术，为客户提供交互式服务的智能客服系统。这种系统通过自然语言处理技术、语音识别技术、机器学习技术等，能够理解客户的需求、回答客户的问题、提供解决方案等。
              </p>
              <p>
                也可以帮助企业实现在线服务的智能化人机协作系统，提高坐席服务的效率、降低人力开销及新人业务知识学习成本。
              </p>
            </div>
          </div>
        </div>
      </section>
      <!--AIGC生成图文-->
      <section class="card card4">
        <div class="titleFloor">
          <img src="/img/about/block2-功能介绍装饰.png" alt="" class="iconDecorate">
          <img src="/img/about/block2-生成图文1.png" alt="" class="iconTitle">
        </div>
        <div class="contentFloor">
          <div class="contentWrapper">
            <img src="/img/about/block2-生成图文2.png" alt="" class="imgTitle">
            <div class="content">
              <p>
                AIGC生成图文是指利用人工智能技术生成和优化图像与文字的结合。这种技术可以自动对图像进行分类、识别、分割、生成等操作，同时结合文字描述，实现图像与文字的有机结合，提高信息的表达能力和可读性。
              </p>
              <p>
                2023年被称为生成式人工智能的突破之年。这项技术从单一的语言生成逐步向多模态、具身化快速发展。在图文生成方面，生成系统在解释提示和生成逼真输出方面取得了显著的进步。
              </p>
              <p>
                生成式人工智能技术在各行业、各领域都具有广泛的应用前景。当今社会是新媒体的时代，每个企业都需要大量的图文宣传工作，传统的写作不仅耗费时间，还有大量的人力成本投入，人工智商城通过利用智能图文生成技术，为中小企业发展带来新的营销方式和便捷的工作方法，节省了企业开支，加速了企业利用智能图文宣传推广的便捷性和快速高效性。
              </p>
            </div>
          </div>
          <img src="/img/about/block2-生成图文图.png" alt="" class="imgMain">
        </div>
      </section>
      <!--数字人定制-->
      <section class="card card5">
        <div class="titleFloor">
          <img src="/img/about/block2-功能介绍装饰.png" alt="" class="iconDecorate">
          <img src="/img/about/block2-数字人定制1.png" alt="" class="iconTitle">
        </div>
        <div class="contentFloor">
          <img src="/img/about/block2-数字人定制图.png" alt="" class="imgMain">
          <div class="contentWrapper">
            <img src="/img/about/block2-数字人定制2.png" alt="" class="imgTitle">
            <div class="content">
              <p>
                中国数字人知识产权存证保护平台2023年6月17日正式上线，标志着数字人有了自己合法合归的身份，也是数字人产业未来发展的坚实基础。
              </p>
              <p>
                根据企业需求，制定出符合条件的需求数字人，包含提供二次元、3D卡通、超写实、真人等多类型虚拟人不同形象、满足不同场景、不同语言等需求。
              </p>
              <p>
                当前最前沿的超写实数字人是指通过技术合成、尽可能贴合真人的“虚拟形象”，通俗的说就是在视觉效果上，比如在神态表情上、工作习惯上与真人特别接近，能帮助企业培训和企业服务管理等。同时超写实数字人在直播、宣传、短视频生成等方面，定制需求巨大，也是目前数据人的热门应用方向。
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>

<style scoped lang="scss">
section.block2 {
  background: #F5F5F9;

  .blockCenter {
    @include glx-center-block-w1280();

    background: #FFFFFF;
    padding-top: 92px;

    position: relative;
    z-index: 0;

    > .titleWrapper {
      position: absolute;
      top: -30px;
      left: 422px;

      .imgTitle {
        object-fit: none;
      }
    }

    .card {
      padding-right: 67px;
      position: relative;

      &::before {
        content: '';
        display: block;
        position: absolute;
        left: 44px;
        top: 16px;
        bottom: 13px;

        width: 1px;
        background: rgba(#1628D1, 0.4);
      }

      .titleFloor {
        position: relative;
        padding-left: 40px;

        .iconDecorate {
          display: block;
          object-fit: none;
        }

        .iconTitle {
          object-fit: none;
          display: block;
          position: absolute;
          left: 87px;
          top: -20px;
        }
      }

      > .contentFloor {
        display: flex;
        align-items: stretch;
        justify-content: space-between;
        margin-top: 66px;
        padding-left: 128px;

        img.imgMain {
          display: block;
          border-radius: 4px;
          object-fit: none;
        }

        > .contentWrapper {
          .imgTitle {
            object-fit: none;
          }

          .content {
            p {
              font-family: Source Han Sans CN;
              font-weight: 400;
              font-size: 16px;
              color: #26262C;
              line-height: 24px;
              margin-top: 26px;
            }
          }
        }
      }

      &.card1 {
        padding-bottom: 103px;

        > .contentFloor {
          > .contentWrapper {
            padding-top: 20px;
            width: 561px;

            .content {
              margin-top: 22px;

              .line {
                width: 566px;
                height: 1px;
                background: #1628D1;
                margin-top: 22px;
              }

              p.p1 {
                margin-top: 25px;
              }
            }
          }
        }
      }

      &.card2 {
        padding-bottom: 84px;

        > .contentFloor {
          > .contentWrapper {
            width: 555px;
            padding-top: 73px;

            .content {
              margin-top: 24px;
            }
          }
        }
      }

      &.card3 {
        padding-bottom: 71px;

        > .contentFloor {

          > .contentWrapper {
            width: 561px;
            padding-top: 50px;

            .content {
              margin-top: 23px;
            }
          }
        }
      }

      &.card4 {
        padding-bottom: 84px;

        > .contentFloor {

          > .contentWrapper {
            width: 561px;
            padding-top: 77px;

            > .content {
              margin-top: 20px;
            }
          }
        }
      }

      &.card5 {
        padding-bottom: 93px;

        > .contentFloor {

          > .contentWrapper {
            width: 547px;
            padding-top: 103px;

            > .content {
              margin-top: 20px;
            }
          }
        }
      }
    }
  }
}
</style>